import PropTypes from 'prop-types'
import { useState } from 'react'
import Measure from 'react-measure'
import { kuiperClassNames } from '@opallabs/kuiper'
import { AccountName } from '../../../../AccountName'
import { ContentTextInput } from '../../../../ContentTextInput'
import { addCaption } from '../staticText'
import { accountName } from './styles'

const onResize = ({ contentRect, setAccountWidth }) => {
  if (!contentRect.entry) return

  const width = contentRect.entry.width + 3
  setAccountWidth(width)
}

export const TextAreaWithAccountName = ({
  accountMeasurerStyle,
  characterCounterOptions = { offset: 48, position: 'right' },
  contentCharacterLimit,
  content,
  display,
  maxRows,
  onContentChange,
  placeholder,
  postType,
  index = 0,
  readOnly,
  style,
  textareaStyle,
  truncate = false,
  truncationLimit,
  username,
}) => {
  const [accountWidth, setAccountWidth] = useState(null)

  if (username) {
    return (
      <div
        css={style}
        className={kuiperClassNames('instagram-combined-textarea-account')}
      >
        <ContentTextInput
          ariaLabel={
            postType?.includes('carousel')
              ? `Carousel Text ${index}`
              : 'Content Text'
          }
          forceLTR={true}
          characterCounterOptions={characterCounterOptions}
          style={textareaStyle}
          characterLimit={contentCharacterLimit}
          readOnly={readOnly}
          highlightSocialTags={true}
          minRows={1}
          maxRows={maxRows}
          onChange={onContentChange}
          placeholder={placeholder || addCaption}
          textIndent={
            display === 'desktopSingle' && username.length >= 30
              ? 0
              : accountWidth
          }
          truncate={truncate}
          truncationLimit={truncationLimit}
          value={content || ''}
        />
        <Measure
          onResize={(contentRect) => onResize({ contentRect, setAccountWidth })}
        >
          {({ measureRef }) => (
            <span
              ref={measureRef}
              css={accountMeasurerStyle}
              className={kuiperClassNames('instagram-account-measurer')}
            >
              <AccountName name={username} style={accountName(display)} />
            </span>
          )}
        </Measure>
      </div>
    )
  }

  return (
    <div
      css={style}
      className={kuiperClassNames('instagram-combined-textarea-account')}
    >
      <ContentTextInput
        ariaLabel={
          postType?.includes('carousel')
            ? `Carousel Text ${index}`
            : 'Content Text'
        }
        characterCounterOptions={characterCounterOptions}
        highlightSocialTags={true}
        forceLTR={true}
        characterLimit={contentCharacterLimit}
        style={textareaStyle}
        readOnly={readOnly}
        minRows={1}
        onChange={(value) => onContentChange(value)}
        placeholder={placeholder || addCaption}
        truncate={truncate}
        truncationLimit={truncationLimit}
        value={content}
      />
    </div>
  )
}

TextAreaWithAccountName.propTypes = {
  accountMeasurerStyle: PropTypes.object,
  characterCounterOptions: PropTypes.shape({
    position: PropTypes.oneOf(['right', 'left', 'top', 'bottom']),
    offset: PropTypes.number,
  }),
  content: PropTypes.string,
  contentCharacterLimit: PropTypes.number,
  display: PropTypes.string,
  index: PropTypes.number,
  isPresenting: PropTypes.bool,
  maxRows: PropTypes.number,
  onContentChange: PropTypes.func,
  placeholder: PropTypes.string,
  postType: PropTypes.string,
  readOnly: PropTypes.bool,
  style: PropTypes.object,
  textareaStyle: PropTypes.func,
  truncate: PropTypes.bool,
  truncationLimit: PropTypes.number,
  username: PropTypes.string,
}
